import { Panel } from "primereact/panel";
import { TextField } from "../../../components/TextField";
import { Score } from "../../../components/Score";
import Pie from "../../home/Pie";
import { BarScore } from "../../../components/BarScore";
 
 
export const InstituicaoPagamentoSintetico = (data: any) => {
  const report = data?.result ?? null;
  const getValue = (value?: string): string => value || "Não informado";
  

  const createPrazo = () => {
    const series: any[] = [];
    series.push({name:'Longo prazo', y:report.percentual_longo_prazo})
    series.push({name:'Curto prazo', y:report.percentual_curto_prazo})
    series.push({name:'Médio prazo', y:report.percentual_medio_prazo})
    return series
  }

  const createVencido = () => {
    const series: any[] = [];
    series.push({name:'Financiamento veículo', y:report.percentual_financiamentos_veiculos_vencidos})
    series.push({name:'Financiamento imobiliários', y:report.percentual_financiamentos_imobiliarios_vencidos})
    series.push({name:'Adiantamento depositante', y:report.percentual_adiantamentos_depositantes_vencidos})
    series.push({name:'Empréstimos', y:report.percentual_emprestimos_vencidos})
    series.push({name:'Cartão', y:report.percentual_cartao_vencido})
    series.push({name:'Financiamentos', y:report.percentual_financiamentos_vencidos})
    
    return series
  }

  const createCategoria = () => {
    const series: any[] = [];
    series.push({name:'Cartão', y:report.percentual_cartao})
    series.push({name:'Empréstimo', y:report.percentual_emprestimos})
    series.push({name:'Financiamento Veículos', y:report.percentual_financiamentos_veiculos})
    series.push({name:'Financiamento imobiliários', y:report.percentual_financiamentos_imobiliarios})
    series.push({name:'Adiantamento depositante', y:report.percentual_adiantamentos_depositantes})
    series.push({name:'Outros', y:report.percentual_outros})
    series.push({name:'Financiamentos', y:report.percentual_financiamentos})
    
    
    return series;
  }
    
 
  return (
    <div style={{ width: "98%" }}>
      <Panel header="Dado Comportamental de Pagamento">
        
        <Panel header="Dados da Consulta">
          <section style={{ display: "grid", gridTemplateColumns: "1fr 1fr" }}>
            <div>
              <TextField
                label="Documento"
                value={getValue(report?.documento)}
              />
              <TextField
                label="Instituições"
                value={getValue(report?.qtd_instituicoes )}
              />
              <TextField
                label="Carteira vencida"
                value={getValue(report?.carteira_vencida)}
              />
              <TextField
                label="Crédito pessoal"
                value={getValue(report?.indice_credito_pessoal)}
              />
              <TextField
                label="Faixa global"
                value={getValue(report?.indice_global)}
              />
              <TextField
                label="Carteira a vencer"
                value={getValue(report?.carteira_vencer)}
              />
              <TextField
                label="Evolução compromissos"
                value={getValue(report?.evolucao_compromissos)}
              />
              <TextField
                label="Operações"
                value={getValue(report?.qtd_operacoes)}
              />
              
            </div>
            <div>
              <TextField
                label="Relacionamento"
                value={getValue(report?.relacionamentos)}
              />
              <TextField
                label="Situação"
                value={getValue(
                  report?.situacao
                )}
              />
              <TextField
                label="Faixa cartão"
                value={getValue(report?.indice_cartao)}
              />
              <TextField
                label="Faixa cheque"
                value={getValue(report?.indice_cheque)}
              />
              <TextField
                label="Perfil cliente"
                value={getValue(report?.perf_cliente)}
              />
               <TextField
                label="Evolução financiamento"
                value={getValue(report?.evolucao_compromissos_financiamentos)}
              />
              <TextField
                label="Evolução cartão"
                value={getValue(report?.evolucao_compromissos_cartao)}
              />
              <TextField
                label="Volume"
                value={getValue(report?.volume)}
              />
            </div>
          </section>
        </Panel>
 
        <br />
         <div className="grid">
          <div className="col p-fluid flex flex-wrap">
            <div >
              <Pie title='Categorias' series={createCategoria()}></Pie>
            </div>
          </div>
          <div className="col">
            <div >
              <Pie title='Prazo' series={createPrazo()}></Pie>
            </div>
          </div>
          <div className="col">
            <div >
              <Pie title='Vencidos' series={createVencido()}></Pie>
            </div>
          </div>
        </div>
       
        {report?.score && (
          <Panel header="Score">
            <div style={{ display: "flex", gap: "40px" }}>
              <div
                className="scrScore"
                
              >
                <Score
                  score={report?.score}
                  range={report?.score}
                />
              </div>
  
              <BarScore
                score={report?.score}
                rangeColor={report?.score}
              />
            </div>
  
            <p style={{ fontWeight: "bold" }}>
              IMPORTANTE:{" "}
              <span style={{ fontWeight: "normal", fontStyle: "italic" }}>
                a decisão de aprovação ou não do crédito é de exclusiva
                responsabilidade do concedente. as informações prestadas pelo
                provedor tem como objevo subsidiar essas decisões e, em hipótese
                alguma devem ser ulizadas como justicativa, pelo concedente do
                crédito, para a tomada da referida decisão.
              </span>
            </p>
          </Panel>
        )}
 
        <br />
      
 
        
      </Panel>
    </div>
  );
};